var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgHeader1 = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 1440 264"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#AFB8F0",
  d: "M-5.857-6.188v115.913c77.503 45.107 244.653 165.886 535.153 153.14 290.481-12.752 291.117-170.37 918.474-39.445V-6.185z"
})));
export default SvgHeader1;